module.exports = __webpack_public_path__ + "static/media/BUSD-logo.c2374261.png";